export var SubEntityType;
(function (SubEntityType) {
    SubEntityType["Bulletins"] = "bulletins";
    SubEntityType["Awards"] = "awards";
    SubEntityType["Reviews"] = "reviews";
})(SubEntityType || (SubEntityType = {}));
